/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './SupplyMaterialList.scss';
import { withTranslation } from 'react-i18next';
import { Badge, Button, Form, Modal, OverlayTrigger, Table } from 'react-bootstrap';
import Pagination from "../../../components/Pagination/Pagination";
import { BiDownload, BiMenuAltRight, BiPencil, BiSearch, BiShareAlt, BiSort, BiPlus } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { DEFAULT_ITEMS_PER_PAGE, LIST_DEF_SORT, SORT_ORDER_DESC } from '../../../core/constants/common';
import nodataimg from '../../../images/nodatafound.png'
import SupplyMaterialService from '../../../core/service/SupplyMaterialService';
import Utils from '../../../core/utilities/Utils';
import { toast } from "react-toastify";
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';
import { FcFinePrint } from "react-icons/fc";


const SupplyMaterialList = ({ t }) => {
  var data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [maintabledata, setMainTableData] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeonly, setActiveOnly] = useState(false);


  const [show, setShow] = useState(false);
  const [editid, setEditId] = useState(null);
  const [editnamevalue, setEditNamevalue] = useState(null);
  const [editstatusvalue, setEditStatusvalue] = useState(true);
  const handleClose = () => {
    setEditId(null);
    setEditNamevalue(null);
    setEditStatusvalue(true);
    setShow(false);
  }
  const handleShow = () => setShow(true);

  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
  };
  useEffect(() => {
    getMainTableList(0, itemsPerPage, key, sortField, activeonly);
  }, []);
  const getMainTableList = (pageNumber, itemsPerPageVal, key, sortField, activeOnly) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }

    var sort = sortField + "," + order;
    SupplyMaterialService.getMaterialList(pageNumber, perPage, key, sort, company, activeOnly)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableData([...response.data]);
        // console.log(response.data);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };
  const editData = (item) => {
    setEditId(item.id);
    setEditNamevalue(item.name);
    setEditStatusvalue(item.active);
    handleShow();
  };

  const handleSubmit = async (e) => {
    var body = {
      name: editnamevalue,
      active: editstatusvalue
    }
    if (editid) {
      body['id'] = editid;
    }
    // console.log('submit------------',body);
    // return
    SupplyMaterialService.onSubmit(company, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleClose();
          getMainTableList(0, itemsPerPage, key, sortField, activeonly);
        }
      })
      .catch((error) => {
        console.log('error', error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

  }
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getMainTableList(0, itemsPerPage, searchKey, sortField, activeonly);
  };
  return (
    <div className="SupplierList">
      <div className="List_header">
        <h5 className="MH">{t("Materials.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            {/* <li>
                <Button variant="secondary" className="">
                  <BiDownload /> {t("Import.label")}
                </Button>
              </li> */}
            <li>
              <Button variant="primary"  onClick={handleShow}>
                <BiPlus />
                {t("New.label")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
      <p className='title-help'>{t("MaterialsHelp.label")}</p>



      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={key}
                  onChange={handleSearch}
                  placeholder="Search by Supply Material"

                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="List_table-card01_sort">
            <ul>
              {/* <li>
                  <a href='#'><BiShareAlt /> {t("Share.label")}</a>
                </li>
                <li>
                  <a href='#'><BiMenuAltRight /> {t("Sort.label")}</a>
                </li> */}
              {/* <li className='filter'>
                  <a href='#'><CgSortAz /> {t("Filter.label")}</a>
                </li> */}
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                {/* <th>
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th> */}
                <th>{t("SupplyMaterial.label")}</th>
                <th>{t("Risk.label")}</th>
                <th>{t("Status.label")}</th>
                <th>{t("Action.label")}</th>
              </tr>
            </thead>
            {(maintabledata === undefined || maintabledata == null || maintabledata.length === 0) &&
              <tbody>
                <tr>
                  <td colSpan="4" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            {maintabledata && maintabledata !== undefined && maintabledata.length > 0 &&
              <tbody>
                {maintabledata?.map((item) => (
                  <tr key={item.id}>
                    {/* <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td> */}
                    <td>{item.name}</td>
                    <td>{item.risk}</td>
                    <td>
                      <div>
                        {item.active
                          ? <Badge bg="badge-Active">
                            {t("Active.label")}
                          </Badge>
                          : <Badge bg="badge-Inactive">
                            {t("Inactive.label")}
                          </Badge>
                        }
                      </div>
                    </td>
                    <td>
                      <div>
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                          <span><BiPencil className='cursor' onClick={() => editData(item)} /></span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            }
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key, sortField, activeonly);
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
           <Modal.Title as="h5">Add New Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="py-2">
                  <label className='mb-1'>{t("SupplyMaterial.label")}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editnamevalue}
                    required
                    onChange={(e) => setEditNamevalue(e.target.value)}
                  />
                </div>
                <div className="py-2">
                  <label className='mb-1'>{t("Status.label")}</label>
                  <select className="form-select" value={editstatusvalue} onChange={(e) => setEditStatusvalue(e.target.value)}>
                    <option value={true}>{t("Active.label")}</option>
                    <option value={false}>{t("Inactive.label")}</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
            {t("Create.label")}
          </Button>

        </Modal.Footer>
      </Modal>
    </div>
  )
};


export default withTranslation()(SupplyMaterialList);
